import { Button, Checkbox, Form, Input, Modal } from "antd";
import React, { useState } from "react";
import styles from "./index.module.less";
import banner from "./images/banner.png";
import { Flex } from "react-vant";
import { postCigAuth } from "@/api/tobaccoAuth";
import regexPatterns from "@/utils/regexPatterns";
import { useRequest } from "ahooks";
import Agreement from "./Agreement";
import { agreement1, agreement2, agreement3 } from "./config";
const { Item } = Form;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

const RichContent = (props) => {
  const { content } = props;
  return <div dangerouslySetInnerHTML={{__html: content}}></div>
}

const agreementList = [
  { label: "《对外提供个人信息授权书》", key: "1", children: <RichContent content={agreement1} /> },
  { label: "《敏感个人信息授权书》", key: "2", children: <RichContent content={agreement2} /> },
  { label: "《个人信息授权书》", key: "3", children: <RichContent content={agreement3} /> },
];

const TobaccoAuth = () => {
  const [form] = Form.useForm();
  const [activeKey, setActiveKey] = useState("1");
  // const checked = Form.useWatch("checked", form);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const { run, loading } = useRequest(postCigAuth, {
    manual: true,
    onSuccess: (url) => {
      if (!url) return;
      window.location.href = url;
    },
  });


  const handleClick = (key) => {
    setActiveKey(key);
    setOpen(true);
  };

  const onCancel = () => {
    setOpen(false);
  };

  return (
    <div className={styles.page}>
      <img src={banner} alt="" />
      <div className={styles.content}>
        <Form form={form} size="large" {...layout} onFinish={run}>
          <div className={styles.form}>
            <Item
              label="许可证号"
              name="account"
              rules={[
                { required: true, message: "请输入许可证号" },
                { len: 12, type: "string", pattern: regexPatterns.positiveInteger, message: "请输入12位许可证号" },
              ]}
            >
              <Input placeholder="请输入许可证号" type="number" />
            </Item>
            {/* 添加法定代表人/经营者姓名字段 */}
            <Item
              label="法定代表人/经营者姓名"
              name="legalName"
              rules={[
                { required: true, message: "请输入法定代表人/经营者姓名" },
              ]}
            >
              <Input placeholder="请输入法定代表人/经营者姓名" />
            </Item>
            {/* 添加法定代表人/经营者身份证号字段 */}
            <Item
              label="法定代表人/经营者身份证号"
              name="identityCard"
              rules={[
                { required: true, message: "请输入法定代表人/经营者身份证号" },
                { pattern: regexPatterns.idCard, message: "请输入正确的身份证号" },
              ]}
            >
              <Input placeholder="请输入法定代表人/经营者身份证号" />
            </Item>
            <Item
              label="法定代表人/经营者手机号"
              name="phone"
              rules={[
                { required: true, message: "请输入法定代表人/经营者手机号" },
                { pattern: regexPatterns.phone, message: "请输入正确的法定代表人/经营者手机号" },
              ]}
            >
              <Input placeholder="请输入法定代表人/经营者手机号" type="tel" />
            </Item>
            {/* 删除 Form.Item 中的验证码字段 */}
          </div>
          <Flex align="center" justify="center" wrap="wrap" className={styles.row}>
            <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
              我已阅读并同意
            </Checkbox>
            {agreementList.map((item) => (
              <span onClick={() => handleClick(item.key)} className={styles.agreement}>
                {item.label}
              </span>
            ))}
          </Flex>
          <Button
            disabled={!checked}
            htmlType="submit"
            type="primary"
            size="large"
            className={styles.btn}
            loading={loading}
          >
            下一步
          </Button>
        </Form>
      </div>
      <Agreement
        open={open}
        onCancel={onCancel}
        agreementList={agreementList}
        activeKey={activeKey}
        onChange={setActiveKey}
      />
    </div>
  );
};

export default TobaccoAuth;